"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortField = void 0;
var SortField;
(function (SortField) {
    SortField["Name"] = "name";
    SortField["Buyer"] = "buyer";
    SortField["Deadline"] = "deadline";
    SortField["Insertion"] = "insertion";
    SortField["Available"] = "available";
    SortField["Publication"] = "publication";
    SortField["Expiration"] = "expiration";
    SortField["RelevanceScore"] = "relevanceScore";
})(SortField = exports.SortField || (exports.SortField = {}));
